import type * as lazyIndex from './lazyIndex';
import { LazyAction, LazyModule } from 'owa-bundling';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "TeamsPolicies" */ './lazyIndex'),
    { name: 'TeamsPolicies' }
);

export const lazyGetTeamsPolicies: LazyAction<
    typeof lazyIndex.getTeamsPolicies,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.getTeamsPolicies);

export const lazyIsTeamsChatEnabled: LazyAction<
    typeof lazyIndex.isTeamsChatEnabled,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.isTeamsChatEnabled);

export const lazyIsTeamsMeetNowEnabled: LazyAction<
    typeof lazyIndex.isTeamsMeetNowEnabled,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.isTeamsMeetNowEnabled);

export const lazyIsPrivateMeetingSchedulingEnabled: LazyAction<
    typeof lazyIndex.isPrivateMeetingSchedulingEnabled,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.isPrivateMeetingSchedulingEnabled);
